/**
 * Code 128-C — гутлын серийн дугаарын баркод.
 *
 * ЯАГААД 128-C: тоог ХОСООР кодлодог тул 10 оронтой дугаар 6 тэмдэгт
 * болж, 40мм шошгонд нягт багтана (CLAUDE.md — «Серийн дугаар»).
 *
 * ⚠️ Энэ нь ГОЁЛ БИШ. Дэлгэц дээр гарах зураас нь бодитоор скан
 *    хийгдэнэ. Хуурамч зураас зурвал агуулахын ажилтан уншуулж
 *    чадахгүй, эсвэл буруу барааг уншина.
 *
 * Бүтэц:  [Start C] [хос] … [хос] [шалгах] [Stop]
 */
/**
 * Code 128-ийн 107 тэмдэгтийн зураас/зайн өргөн.
 * Элемент бүр зураас→зай→зураас→зай→зураас→зай, нийлбэр нь ҮРГЭЛЖ 11.
 */
const PATTERNS = [
    '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312',
    '132212', '221213', '221312', '231212', '112232', '122132', '122231', '113222',
    '123122', '123221', '223211', '221132', '221231', '213212', '223112', '312131',
    '311222', '321122', '321221', '312212', '322112', '322211', '212123', '212321',
    '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
    '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121',
    '313121', '211331', '231131', '213113', '213311', '213131', '311123', '311321',
    '331121', '312113', '312311', '332111', '314111', '221411', '431111', '111224',
    '111422', '121124', '121421', '141122', '141221', '112214', '112412', '122114',
    '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
    '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112',
    '421211', '212141', '214121', '412121', '111143', '111341', '131141', '114113',
    '114311', '411113', '411311', '113141', '114131', '311141', '411131', '211412',
    '211214', '211232', '233111',
];
/** Start C. Эндээс хойш цифрүүд хосоороо кодлогдоно. */
export const CODE128_START_C = 105;
/** Stop. Төгсгөлд нь нэмэлт 2 модулийн зураас залгагдана. */
export const CODE128_STOP = 106;
/** Тэмдэгт бүр 11 модуль, Stop нь 13 (төгсгөлийн зураастайгаа). */
export const CODE128_SYMBOL_MODULES = 11;
export const CODE128_STOP_MODULES = 13;
/**
 * Code 128-C-ийн шалгах тэмдэгт.
 *
 * (Start + Σ байрлал × утга) mod 103. Байрлал 1-ээс эхэлнэ,
 * Start өөрөө тооцоонд 1 удаа орно.
 */
export function code128Checksum(startValue, values) {
    let sum = startValue;
    for (const [i, v] of values.entries())
        sum += (i + 1) * v;
    return sum % 103;
}
/** Code B руу шилжих тэмдэгт (Code C дотроос). */
export const CODE128_CODE_B = 100;
/**
 * Тоон мөрийг Code 128-C болгож кодлоно.
 *
 * Сондгой урттай бол (бизнесийн 11 оронтой баркод) эхний хосууд C-ээр,
 * СҮҮЛИЙН ганц цифр `Code B`-д шилжиж кодлогдоно — 128-C нь ганц цифр
 * илэрхийлж чаддаггүй. Энэ нь стандарт уншигчид ил тод: сканнер
 * «44609193703»-ыг бүтнээр нь өгнө.
 *
 * @param digits ЗӨВХӨН цифр
 */
export function encodeCode128C(digits) {
    if (!/^\d+$/.test(digits)) {
        throw new Error(`encodeCode128C: зөвхөн цифр байх ёстой, ирсэн: "${digits}"`);
    }
    const pairs = [];
    for (let i = 0; i + 1 < digits.length; i += 2) {
        pairs.push(Number(digits.slice(i, i + 2)));
    }
    if (digits.length % 2 !== 0) {
        // Code B-д цифрийн утга = ASCII − 32 ('0' → 16)
        pairs.push(CODE128_CODE_B, digits.charCodeAt(digits.length - 1) - 32);
    }
    const checksum = code128Checksum(CODE128_START_C, pairs);
    const symbols = [CODE128_START_C, ...pairs, checksum, CODE128_STOP];
    const bars = [];
    let x = 0;
    for (const [index, symbol] of symbols.entries()) {
        const isStop = index === symbols.length - 1;
        // Stop-д төгсгөлийн 2 модулийн зураас нэмэгдэнэ
        const widths = (PATTERNS[symbol] + (isStop ? '2' : '')).split('').map(Number);
        for (const [j, w] of widths.entries()) {
            if (j % 2 === 0)
                bars.push({ x, width: w }); // тэгш индекс = зураас
            x += w;
        }
    }
    return { bars, totalModules: x, symbols, checksum };
}
/** Серийн дугаарын баркодын нийт өргөн (модуль). 10 орон → 90, 11 → 112. */
export function code128CModuleCount(digitCount) {
    // Start + хосууд (+ Code B + сүүлийн цифр) + шалгах
    const symbols = 1 + Math.floor(digitCount / 2) + (digitCount % 2) * 2 + 1;
    return symbols * CODE128_SYMBOL_MODULES + CODE128_STOP_MODULES;
}
//# sourceMappingURL=barcode.js.map